import { render, staticRenderFns } from "./GnvUnder18Modal.vue?vue&type=template&id=47c7ad23"
import script from "./GnvUnder18Modal.vue?vue&type=script&lang=js"
export * from "./GnvUnder18Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports